import React from 'react';
import { Link } from 'react-router-dom';

function HelpCenter() {
  const supportCategories = [
    {
      id: 'maintenance',
      icon: '🛠️',
      title: 'Maintenance & Care',
      description: 'Keep your robots running at peak efficiency',
      articles: [
        {
          title: 'Preventive Maintenance Schedule',
          content: 'Recommended maintenance intervals and procedures.',
          tags: ['maintenance', 'schedule']
        },
        {
          title: 'Cleaning Procedures',
          content: 'Proper cleaning methods for different robot components.',
          tags: ['cleaning', 'care']
        },
        {
          title: 'Parts Replacement Guide',
          content: 'Instructions for replacing wear components and consumables.',
          tags: ['parts', 'replacement']
        },
        // {
        //   title: 'Software Updates',
        //   content: 'How to update firmware and control software safely.',
        //   tags: ['updates', 'firmware']
        // }
      ]
    },
    {
      id: 'safety',
      icon: '🛡️',
      title: 'Safety & Compliance',
      description: 'Safety protocols and regulatory compliance',
      articles: [
        {
          title: 'Safety Guidelines',
          content: 'Essential safety procedures for robot operation.',
          tags: ['safety', 'guidelines']
        },
        {
          title: 'Emergency Procedures',
          content: 'Emergency stop protocols and incident response.',
          tags: ['emergency', 'safety']
        },
        {
          title: 'Regulatory Compliance',
          content: 'Industry standards and certification information.',
          tags: ['compliance', 'regulations']
        }
      ]
    },
    {
      id: 'training',
      icon: '🎓',
      title: 'Training Resources',
      description: 'Educational materials and training programs',
      articles: [
        {
          title: 'Operator Training Modules',
          content: 'Comprehensive training for robot operators.',
          tags: ['training', 'operator']
        },
        {
          title: 'Advanced Programming',
          content: 'Learn advanced programming and customization techniques.',
          tags: ['programming', 'advanced']
        },
        {
          title: 'Video Tutorials',
          content: 'Step-by-step video guides for common operations.',
          tags: ['videos', 'tutorials']
        }
      ]
    }
  ];

  const contactMethods = [
    {
      icon: '📞',
      title: '24/7 Technical Support',
      description: 'Round-the-clock assistance for critical issues',
      action: 'Call Now',
      link: 'tel:+919370329886',
      isExternal: true
    },
    {
      icon: '📧',
      title: 'Email Support',
      description: 'Get detailed responses to your questions',
      action: 'Send Email',
      link: 'mailto:ashmantechnical@gmail.com',
      isExternal: true
    },
    {
      icon: '📄',
      title: 'Product Manuals',
      description: 'Download comprehensive user manuals',
      action: 'View Manuals',
      link: '/contact',
      isExternal: false
    },
      // {
      //   icon: '🔄',
      //   title: 'Software Updates',
      //   description: 'Access latest firmware and software',
      //   action: 'Get Updates',
      //   link: '/contact',
      //   isExternal: false
      // }
  ];

  return (
    <section className="help-center">
      <div className="container">
        {/* Header */}
        <div className="help-header">
          <h1>👨‍🔧 Help Center</h1>
          <p className="help-intro">
            Technical support and documentation for Aashman Technicals robotics solutions
          </p>
        </div>

        {/* Support Categories Grid */}
        <div className="support-categories">
          {supportCategories.map(category => (
            <div key={category.id} className="category-card">
              <div className="category-header">
                <span className="category-icon">{category.icon}</span>
                <h3>{category.title}</h3>
              </div>
              <p className="category-description">{category.description}</p>
              
              <div className="articles-list">
                {category.articles.map((article, idx) => (
                  <div key={idx} className="article-item">
                    <h4>{article.title}</h4>
                    <p>{article.content}</p>
                    <div className="article-tags">
                      {article.tags.map((tag, tidx) => (
                        <span key={tidx} className="tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Contact Support Section */}
        <div className="contact-support-section">
          <h2>🤝 Need More Help?</h2>
          <p>Our technical support team is here to assist you</p>
          
          <div className="contact-methods">
            {contactMethods.map((method, idx) => (
              method.isExternal ? (
                <a key={idx} href={method.link} className="contact-method-card">
                  <span className="method-icon">{method.icon}</span>
                  <h4>{method.title}</h4>
                  <p>{method.description}</p>
                  <span className="method-action">{method.action} →</span>
                </a>
              ) : (
                <Link key={idx} to={method.link} className="contact-method-card">
                  <span className="method-icon">{method.icon}</span>
                  <h4>{method.title}</h4>
                  <p>{method.description}</p>
                  <span className="method-action">{method.action} →</span>
                </Link>
              )
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HelpCenter;